module.exports = __webpack_public_path__ + "static/media/191CS205.3bbc2178.jpeg";